import * as angular from 'angular';
import SankeyDiagramComponent from './sankeyDiagram/sankeyDiagram.component';
import LabeledColorCard from './labeledColorCard/labeledColorCard.component';
import CounterChildCard from './counterChildCard/counterChildCard.component';
import GeneralDashboard from './tabs/generalDashboard.component';
import CustomReports from './tabs/customReports.component';
import ContactsJourney from './tabs/contactsJourney.component';
import Dashboard from './tabs/dashboard.component';
export const analyticsComponents = angular
    .module('analyticsComponents')
    .component('generalDashboard', GeneralDashboard)
    .component('customReports', CustomReports)
    .component('contactsJourney', ContactsJourney)
    .component('sankeyDiagram', SankeyDiagramComponent)
    .component('labeledColorCard', LabeledColorCard)
    .component('counterChildCard', CounterChildCard)
    .component('dashboard', Dashboard)
    .name;
